import template from './component.tpl.html';
import AlLandingpageEditorComponentController from './controller';

/** Include sub components */
import './pages/form/component';
import './pages/landing/component';
import './pages/studio/component';
import './general/component';

/**
 * @ngdoc component
 * @name festzelt-os.modules.guestlists.component:al-landingpage-editor
 * @restrict EA
 * @element
 *
 * @description
 *
 * @example
 <example module="festzelt-os.modules.guestlists">
 <file name="index.html">
 <al-landingpage-editor guestlist="{}"></al-landingpage-editor>
 </file>
 </example>
 *
 */
angular
    .module('festzelt-os.modules.media')
    .component('alLandingpageEditor', {
        bindings: {
            guestlist: '<',
            onModelUpdate: '&',
            onContactCustomFieldUpdate: '&',
            onExternalRouteStart: '&',
            externalViewTrigger: '<'
        },
        controller: AlLandingpageEditorComponentController,
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/modules/guestlists/components/al-landingpage-editor/component.js